import { render, staticRenderFns } from "./GroupCreatedNewGroup.vue?vue&type=template&id=236f7ac2&scoped=true"
import script from "./GroupCreatedNewGroup.vue?vue&type=script&lang=js"
export * from "./GroupCreatedNewGroup.vue?vue&type=script&lang=js"
import style0 from "./GroupCreatedNewGroup.vue?vue&type=style&index=0&id=236f7ac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f7ac2",
  null
  
)

export default component.exports